import { ethers } from "ethers";
import environment from "../environment";
import config from "../config";

const useErrorHelpers = () => {
  const getErrorReason = async (txHash: string, chainId?: number) => {
    if (!txHash || txHash === null || txHash === undefined) return undefined;
    
    try {
      // Use provided chainId or fall back to config chainId
      const currentChainId = chainId || config.chainId;
      const rpcUrl = environment.getRpcUrlByChainId(currentChainId);
      
      if (!rpcUrl) {
        console.error("No RPC URL found for chainId:", currentChainId);
        return undefined;
      }
      
      const provider = new ethers.JsonRpcProvider(rpcUrl);
      const tx = await provider.getTransaction(txHash);

      if (tx === null || tx === undefined) return undefined;
      const code = await provider.call(tx);
      let codeString = `0x${code.substr(138)}`.replace(/0+$/, "");
      // If the codeString is an odd number of characters, add a trailing 0
      if (codeString.length % 2 === 1) {
        codeString += "0";
      }
      
      // Convert hex to ASCII using ethers
      const encodeError = ethers.toUtf8String(codeString);
      return mappingError(encodeError);
    } catch (error) {
      console.error("Error getting error reason:", error);
      return undefined;
    }
  };
  const mappingError = (error: any) => {
    let returnError;
    console.log("error=", error);
    switch (true) {
      case String(error).includes("INSUFFICIENT_OUTPUT_AMOUNT"):
        returnError =
          "Transaction failed due to price changes unfavorably more than % of slippage settings";
        break;
      case String(error).includes("EXPIRED"):
        returnError =
          "The transaction failed because it was not completed within the timeframe specified in the transaction deadline settings.";
        break;
      default:
        returnError = undefined;
    }
    return returnError;
  };
  const isErrorClass = (obj: {}) => {
    return Object.prototype.toString.call(obj) === "[object Error]";
  };

  return { getErrorReason, isErrorClass };
};

export default useErrorHelpers;
